import { Eye, Pencil } from "lucide-react"
import { NavLink, useLocation } from "react-router-dom"

import { Button } from "@/components/ui/button"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"

/**
 * document-editor.md's `DocumentEditAction` — a real shared component (also
 * used by `details.md`'s view-mode header with `mode="view"`, not used on
 * this page). `mode="edit"` (the branch `DocumentEdit.tsx` renders) has no
 * tooltip; `mode="view"` does.
 */
export function DocumentEditAction({
  documentId,
  mode,
}: {
  documentId: string
  mode: "view" | "edit"
}) {
  const { pathname, search } = useLocation()
  const documentBase = pathname.startsWith("/documents/search/")
    ? "/documents/search"
    : "/documents"

  if (mode === "edit") {
    return (
      <Button asChild size="lg" variant="secondary">
        <NavLink to={`${documentBase}/${documentId}${search}`}>
          <Eye data-icon="inline-start" />
          Переглянути Документ
        </NavLink>
      </Button>
    )
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button aria-label="Редагувати" asChild size="lg" variant="secondary">
          <NavLink to={`/documents/edit/${documentId}${search}`}>
            <Pencil data-icon="inline-start" />
            Редагувати Документ
          </NavLink>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Редагувати</TooltipContent>
    </Tooltip>
  )
}
